/* These directive extensions are necessary because nested ng-forms
   do not set $submitted when their root form is submitted. */
const formDirectiveDefinition = () => ({
    restrict: 'E',
    require: 'form',
    link(scope, elem, attrs) {
        elem.on('submit', () => {
            if (!('nobroadcast' in attrs)) {
                scope.$broadcast('$submitted');
                scope.$apply();
            }
        });
    },
});

const ngFormDirectiveDefinition = () => ({
    restrict: 'EA',
    require: 'form',
    link(scope, elem, attrs, formCtrl) {
        scope.$on('$submitted', () => {
            formCtrl.$setSubmitted();
        });
    },
});

module.exports = { formDirectiveDefinition, ngFormDirectiveDefinition };



// WEBPACK FOOTER //
// ./src/olycommon/form/form.directive.js